import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';

import { SupportComponent } from '@lib/components/support-class';
import { CommonLibService, ModalService } from '@lib/services';
import { passengerInformationRequestPayloadParts } from '@app/id-modal/passenger-information-request/passenger-information-request.payload.state';
import { CurrentCartStoreService, LocalPlanService } from '@common/services';
import { PassengerInformationRequestEditType } from '@common/interfaces';
import { selectNextPageModalPayloadParts } from '@app/id-modal/passenger-information-request/modal/select-next-page-modal/select-next-page-modal-payload.state';
import {
  getCurrentCartAllChd,
  getCurrentCartAllChdAndAdt,
  getCurrentCartAllChdPnr,
  getCurrentCartDisAbilityDuplicate,
  getCurrentCartDisAbilitySuccess,
  getCurrentCartNotU12AndNotU4,
  getCurrentCartNotU12AndU4,
  getCurrentCartNotU12AndU4Pnr,
  getCurrentCartTestData1,
  getCurrentCartTestData1All21Under,
  getCurrentCartTestData1All21UnderNh,
  getCurrentCartTestData1Eq21,
  getCurrentCartTestData1Eq21Dep,
  getCurrentCartTestData1Nomiddle,
  getCurrentCartTestData2,
  getCurrentCartTestData2All18Under,
  getCurrentCartTestData2Eq18,
  getCurrentCartTestData2Eq18Dep,
  getCurrentCartTestData2Eq18Dep2,
  getCurrentCartTestData3,
  getCurrentCartTestData3All18Under,
  getCurrentCartTestData3Eq18,
  getCurrentCartTestData3Eq18Dep,
  getCurrentCartTestData3Eq18Dep2,
  getCurrentCartTestData4,
  getCurrentCartU12AndU4,
} from '@app/test-ssn/testData/passenger-information-request/passenger-information-request-test-data';
import { TranslateService } from '@ngx-translate/core';
import { AswContextModel } from '@lib/interfaces';

@Component({
  selector: 'asw-passenger-information-request-test',
  templateUrl: './passenger-information-request-test.html',
  styleUrls: ['../../test-ssn.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PassengerInformationRequestTestComponent extends SupportComponent {
  constructor(
    private common: CommonLibService,
    private _changeDetector: ChangeDetectorRef,
    private _currentCartService: CurrentCartStoreService,
    private _localPlanService: LocalPlanService,
    private _translate: TranslateService,
    private modal: ModalService
  ) {
    super(common);
  }

  reload(): void {}
  init(): void {}
  destroy(): void {}

  testButton1(isEditMode: boolean, editarea: number = PassengerInformationRequestEditType.NOT_EDITTING) {
    this._currentCartService.updateCurrentCart({ data: { cartId: 'PassTest001' } });
    const part = passengerInformationRequestPayloadParts(isEditMode, editarea);
    this.modal.showSubPageModal(part);
  }

  testButton(num: string) {
    this._currentCartService.updateCurrentCart({ data: { cartId: 'TESTGETCART_' + num } });
    const part = passengerInformationRequestPayloadParts();
    this.modal.showSubPageModal(part);
  }

  testButton2Edit(isEditMode: boolean, editarea: number = PassengerInformationRequestEditType.NOT_EDITTING) {
    this._currentCartService.updateCurrentCart({ data: { cartId: 'TESTGETCART_1' } });
    const part = passengerInformationRequestPayloadParts(isEditMode, editarea);
    this.modal.showSubPageModal(part);
  }

  cartError(id: string) {
    this._currentCartService.updateCurrentCart({ data: { cartId: 'ERRGETCART_' + id } });
    const part = passengerInformationRequestPayloadParts();
    this.modal.showSubPageModal(part);
  }

  prebookError(id: string) {
    this._currentCartService.updateCurrentCart({ data: { cartId: 'ERRDELETEPREBOOKEDORDER_' + id } });
    const part = passengerInformationRequestPayloadParts();
    this.modal.showSubPageModal(part);
  }

  updateError(id: string) {
    this._currentCartService.updateCurrentCart({ data: { cartId: 'ERRUPDATETRAVELER_' + id } });
    const part = passengerInformationRequestPayloadParts();
    this.modal.showSubPageModal(part);
  }

  senisaki1() {
    const update = getCurrentCartTestData1();
    this._currentCartService.setCurrentCart(update);
    this.senisakiOpen();
  }

  senisaki1NoMiddle() {
    const update = getCurrentCartTestData1Nomiddle();
    this._currentCartService.setCurrentCart(update);
    this.senisakiOpen();
  }

  senisaki1U21() {
    const update = getCurrentCartTestData1All21Under();
    this._currentCartService.setCurrentCart(update);
    this.senisakiOpen();
  }

  senisaki1U21Nh() {
    const update = getCurrentCartTestData1All21UnderNh();
    this._currentCartService.setCurrentCart(update);
    this.senisakiOpen();
  }

  senisaki1U21Equal() {
    const update = getCurrentCartTestData1Eq21();
    this._currentCartService.setCurrentCart(update);
    this.senisakiOpen();
  }
  senisaki1U21EqualDep() {
    const update = getCurrentCartTestData1Eq21Dep();
    this._currentCartService.setCurrentCart(update);
    this.senisakiOpen();
  }
  senisaki2() {
    const update = getCurrentCartTestData2();
    this._currentCartService.setCurrentCart(update);
    this.senisakiOpen();
  }
  senisaki2U18() {
    const update = getCurrentCartTestData2All18Under();
    this._currentCartService.setCurrentCart(update);
    this.senisakiOpen();
  }
  senisaki2U18Equal() {
    const update = getCurrentCartTestData2Eq18();
    this._currentCartService.setCurrentCart(update);
    this.senisakiOpen();
  }
  senisaki2U18EqualDep() {
    const update = getCurrentCartTestData3Eq18Dep();
    this._currentCartService.setCurrentCart(update);
    this.senisakiOpen();
  }
  senisaki2U18EqualDep2() {
    const update = getCurrentCartTestData2Eq18Dep2();
    this._currentCartService.setCurrentCart(update);
    this.senisakiOpen();
  }
  senisaki3() {
    const update = getCurrentCartTestData3();
    this._currentCartService.setCurrentCart(update);
    this.senisakiOpen();
  }
  senisaki3U18() {
    const update = getCurrentCartTestData3All18Under();
    this._currentCartService.setCurrentCart(update);
    this.senisakiOpen();
  }
  senisaki3U18Equal() {
    const update = getCurrentCartTestData3Eq18();
    this._currentCartService.setCurrentCart(update);
    this.senisakiOpen();
  }
  senisaki3U18EqualDep() {
    const update = getCurrentCartTestData3Eq18Dep();
    this._currentCartService.setCurrentCart(update);
    this.senisakiOpen();
  }
  senisaki3U18EqualDep2() {
    const update = getCurrentCartTestData3Eq18Dep2();
    this._currentCartService.setCurrentCart(update);
    this.senisakiOpen();
  }

  senisakiNotU12AndU4() {
    const update = getCurrentCartNotU12AndU4();
    this._currentCartService.setCurrentCart(update);
    this.senisakiOpen();
  }
  senisakiU12AndU4() {
    const update = getCurrentCartU12AndU4();
    this._currentCartService.setCurrentCart(update);
    this.senisakiOpen();
  }
  senisakiNotU12AndNotU4() {
    const update = getCurrentCartNotU12AndNotU4();
    this._currentCartService.setCurrentCart(update);
    this.senisakiOpen();
  }
  senisakiNotU12AndU4Pnr() {
    const update = getCurrentCartNotU12AndU4Pnr();
    this._currentCartService.setCurrentCart(update);
    this.senisakiOpen();
  }

  senisakiAllChd(): any {
    const update = getCurrentCartAllChd();
    this._currentCartService.setCurrentCart(update);
    this.senisakiOpen();
  }
  senisakiAllChdAndAdt(): any {
    const update = getCurrentCartAllChdAndAdt();
    this._currentCartService.setCurrentCart(update);
    this.senisakiOpen();
  }
  senisakiAllChdPnr(): any {
    const update = getCurrentCartAllChdPnr();
    this._currentCartService.setCurrentCart(update);
    this.senisakiOpen();
  }

  senisakiDisAbilityDuplicate(): any {
    const update = getCurrentCartDisAbilityDuplicate();
    this._currentCartService.setCurrentCart(update);
    this.senisakiOpen();
  }
  senisakiDisAbilitySuccess(): any {
    const update = getCurrentCartDisAbilitySuccess();
    this._currentCartService.setCurrentCart(update);
    this.senisakiOpen();
  }

  senisaki4() {
    const update = getCurrentCartTestData4();
    this._currentCartService.setCurrentCart(update);
    this.senisakiOpen();
  }

  senisakiApiError(id: string) {
    const update = getCurrentCartTestData1('ERRCREATEORDER_' + id);
    this._currentCartService.setCurrentCart(update);
    this.senisakiOpen();
  }
  senisakiPnrError() {
    const update = getCurrentCartTestData1('TESTCREATEORDER_1');
    this._currentCartService.setCurrentCart(update);
    this.senisakiOpen();
  }

  senisakiOpen() {
    console.log(this._currentCartService.CurrentCartData);
    const parts = selectNextPageModalPayloadParts(false);
    parts.payload = {
      order: '0',
    };
    this.modal.showSubModal(parts);
  }

  posChange(pos: string) {
    this.common.aswContextStoreService.updateAswContext({ posCountryCode: pos });
  }

  officeChange(office: string, pos?: string) {
    let update: Partial<AswContextModel> = { pointOfSaleId: office };
    if (pos) {
      update = { ...update, posCountryCode: pos };
    }
    this.common.aswContextStoreService.updateAswContext(update);
  }
  langChange(lang: string) {
    this.common.aswContextStoreService.updateAswContext({ lang: lang });
    this._translate.use(lang);
  }
}
